var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InlineAtom, SylController, SylPlugin } from '@syllepsis/adapter';
var NAME = 'link';
var LinkController = /** @class */ (function (_super) {
    __extends(LinkController, _super);
    function LinkController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = NAME;
        _this.validateHref = function (value) { return ({ error: false }); };
        _this.toolbar = {
            handler: function (editor) { },
        };
        _this.insert = function (attrs) {
            _this.editor.insertCard(NAME, attrs);
        };
        _this.validateHref = props.validateHref;
        return _this;
    }
    return LinkController;
}(SylController));
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'a'; };
        _this.attrs = {
            href: {
                default: '',
            },
            text: {
                default: '',
            },
        };
        _this.getText = true;
        _this.textMatcher = [
            {
                matcher: /\[(.*)\]\((.*)\)\s/,
                handler: function (match) {
                    return {
                        text: match[1],
                        href: match[2],
                    };
                },
            },
        ];
        _this.parseDOM = [
            {
                tag: 'a[href]',
                getAttrs: function (dom) {
                    if (!dom.textContent && !dom.getAttribute('text')) {
                        return false;
                    }
                    // solve the problem of copying itself
                    var text = dom.textContent || dom.getAttribute('text') || '';
                    return {
                        href: dom.getAttribute('href'),
                        text: text,
                    };
                },
            },
        ];
        _this.toDOM = function (node) { return ['a', { class: 'syl-link', href: node.attrs.href }, node.attrs.text]; };
        return _this;
    }
    return Link;
}(InlineAtom));
var LinkPlugin = /** @class */ (function (_super) {
    __extends(LinkPlugin, _super);
    function LinkPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = LinkController;
        _this.Schema = Link;
        return _this;
    }
    return LinkPlugin;
}(SylPlugin));
export { Link, LinkController, LinkPlugin };
//# sourceMappingURL=index.js.map